import { render, staticRenderFns } from "./PrescriptionList.vue?vue&type=template&id=735a84e2&"
import script from "./PrescriptionList.vue?vue&type=script&lang=js&"
export * from "./PrescriptionList.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionList.vue?vue&type=style&index=0&id=735a84e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports